import { NewAccountButtons } from '../../components/AddAccountDropDown'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'

/**
 * Shows a list of buttons to add new accounts.
 */
function NewAccountPage() {
    return (
        <AccountOnboardingLayout title="Add or re-authorise a profile in Arwen">
            <NewAccountButtons />
        </AccountOnboardingLayout>
    )
}

export default NewAccountPage
